import { useNavigate, useParams } from "react-router-dom";

import { UserEditPage } from "./UserEditPage";
import { UserCreatePage } from "./UserCreatePage";

interface Props {
}

export function UserPage(props: Props) {
  const navigate = useNavigate();
  const params = useParams<{
    userId: string;
  }>();

  function handleClose() {
    navigate(`/users`);
  }

  return render();

  function render() {
    if (params.userId === "new") {
      return <UserCreatePage onClose={handleClose} />;
    } else return <UserEditPage key={Object.values(params).join()} onClose={handleClose} />;
  }
}
